/**
 * Sight presets for printed-tape and rack-and-pinion models.
 * scale: multiplier on geometry-scaled inch output (1 = printed label tape).
 * Spot Hogg rack-and-pinion dial sights use ~1/0.645 (linear vs wheel travel).
 */
(function (global) {
  var RACK_PINION_SCALE = 1 / 0.645;
  var GROUPS = [
    {
      label: 'Printed tape',
      sights: [{ id: 'printed', label: 'Printed label tape (direct inches)', scale: 1 }],
    },
    {
      label: 'Measure with calipers',
      sights: [
        { id: 'inch', label: 'Inch scale', scale: 1 },
        { id: 'metric', label: 'Metric scale', scale: 1 },
      ],
    },
    {
      label: 'Click / target sights',
      sights: [
        { id: '24x10', label: '24 Turn x 10 Clicks', scale: 1 },
        { id: '24x20', label: '24 Turn x 20 Clicks', scale: 1 },
        { id: '28x10', label: '28 Turn x 10 Clicks', scale: 1 },
        { id: '28x20', label: '28 Turn x 20 Clicks', scale: 1 },
        { id: '32x10', label: '32 Turn x 10 Clicks', scale: 1 },
        { id: '32x20', label: '32 Turn x 20 Clicks', scale: 1 },
      ],
    },
    {
      label: 'Manufacturers',
      sights: [
        { id: 'arc-sx10', label: 'Arc System SX10', scale: 1 },
        { id: 'arc-sx200', label: 'Arc System SX200 (20-Click)', scale: 1 },
        { id: 'axcel-xp', label: 'Axcel XP Achieve', scale: 1 },
        { id: 'b3-q2', label: 'B3 Exact Target Q2', scale: 1 },
        { id: 'bg-2a', label: 'Black Gold Competition 2A', scale: 1 },
        { id: 'boss-hogg', label: 'Boss Hogg', scale: 1 },
        { id: 'bowfinger', label: 'Bowfinger', scale: 1 },
        { id: 'bowfinger-v2', label: 'Bowfinger V2', scale: 1 },
        { id: 'cbe-axis', label: 'CBE Axis', scale: 1 },
        { id: 'copper-john', label: 'Copper John', scale: 1 },
        { id: 'fast-eddie', label: 'Spot Hogg Fast Eddie', scale: RACK_PINION_SCALE },
        { id: 'fast-eddie-xl', label: 'Spot Hogg Fast Eddie XL', scale: RACK_PINION_SCALE },
        { id: 'hogg-father', label: 'Hogg Father', scale: RACK_PINION_SCALE },
        { id: 'hoggernaut', label: 'Hoggernaut', scale: 1 },
        { id: 'shibuya-dual', label: 'Shibuya - Dual Click', scale: 1 },
        { id: 'shibuya-cp3', label: 'Shibuya - Ultima CP III', scale: 1 },
        { id: 'shibuya-cp-pro', label: 'Shibuya - Ultima CP PRO', scale: 1 },
        { id: 'shibuya-cp-pro-g2', label: 'Shibuya - Ultima CP PRO G2', scale: 1 },
        { id: 'shibuya-cpx3', label: 'Shibuya - Ultima CPX III', scale: 1 },
        { id: 'shibuya-cpx4', label: 'Shibuya - Ultima CPX IV', scale: 1 },
        { id: 'shibuya-rc3', label: 'Shibuya - Ultima RC III', scale: 1 },
        { id: 'shibuya-rc4', label: 'Shibuya - Ultima RC IV', scale: 1 },
        { id: 'shibuya-rc-pro', label: 'Shibuya - Ultima RC PRO', scale: 1 },
        { id: 'shibuya-rc-pro-g2', label: 'Shibuya - Ultima RC PRO G2', scale: 1 },
        { id: 'sure-loc', label: 'Sure Loc', scale: 1 },
        { id: 'davis-10', label: 'The System by Davis (10 Click)', scale: 1 },
        { id: 'davis-20', label: 'The System by Davis (20 Click)', scale: 1 },
        { id: 'tommy-hogg', label: 'Tommy Hogg', scale: RACK_PINION_SCALE },
        { id: 'tru-ball', label: 'Tru Ball', scale: 1 },
      ],
    },
  ];

  var BY_ID = {};
  for (var g = 0; g < GROUPS.length; g++) {
    var group = GROUPS[g];
    for (var i = 0; i < group.sights.length; i++) {
      BY_ID[group.sights[i].id] = group.sights[i];
    }
  }

  function presetScale(sightId) {
    var p = BY_ID[sightId || 'printed'];
    return p && p.scale > 0 ? p.scale : 1;
  }

  /**
   * Estimate full-draw peep height (in) from brace-height measurement using string-angle geometry.
   * opts: peepHeightAtBraceIn, drawLengthIn, ataIn, braceHeightIn
   */
  function peepHeightFullDrawIn(opts) {
    opts = opts || {};
    var phRest = opts.peepHeightAtBraceIn;
    var dl = opts.drawLengthIn;
    var ata = opts.ataIn;
    var bh = opts.braceHeightIn;
    if (phRest == null || !isFinite(phRest) || phRest <= 0) return null;
    if (dl == null || !isFinite(dl) || dl <= 0) return null;
    if (ata == null || !isFinite(ata) || ata <= 0) return null;
    if (bh == null || !isFinite(bh) || bh <= 0) return null;
    if (dl <= bh) return null;
    var half = ata / 2;
    var thetaDraw = Math.atan(half / (dl - bh + phRest / 3));
    var thetaBrace = Math.atan(half / (bh + phRest));
    if (thetaBrace <= 0) return null;
    return phRest * (Math.sin(thetaDraw) / Math.sin(thetaBrace));
  }

  var BOW_PRESETS = {
    'mathews-mr6': { label: 'Mathews Monster MR6', ataIn: 33, braceHeightIn: 6.0625 },
  };

  function populateSelect(selectEl, selectedId) {
    if (!selectEl) return;
    var html = '';
    for (var g = 0; g < GROUPS.length; g++) {
      var group = GROUPS[g];
      html += '<optgroup label="' + group.label.replace(/"/g, '&quot;') + '">';
      for (var i = 0; i < group.sights.length; i++) {
        var s = group.sights[i];
        html +=
          '<option value="' +
          s.id +
          '"' +
          (s.id === (selectedId || 'printed') ? ' selected' : '') +
          '>' +
          s.label.replace(/</g, '&lt;') +
          '</option>';
      }
      html += '</optgroup>';
    }
    selectEl.innerHTML = html;
  }

  global.TitleXSightTapeSights = {
    groups: GROUPS,
    bowPresets: BOW_PRESETS,
    presetScale: presetScale,
    peepHeightFullDrawIn: peepHeightFullDrawIn,
    populateSelect: populateSelect,
    defaultId: 'printed',
    refPeepToSightIn: 31.25,
    refPeepHeightIn: 4.5,
  };
})(typeof window !== 'undefined' ? window : globalThis);
